import { reduxKey } from './constants';

export enum UserGiftInitStatus {
  Loading = 'loading',
  Initialized = 'initialized',
  FailedToInitialize = 'failed-to-initialize',
}

export interface UserGiftState {
  canBeGivenLlama?: boolean;
  canBeGivenCake?: boolean;
  canBeGivenCore?: boolean;
  initStatus?: UserGiftInitStatus;
}

export interface GiftingStoreSlice {
  [useridUuid: string]: UserGiftState;
}

export interface GiftingStoreState {
  [reduxKey]: GiftingStoreSlice;
}
